

import React from "react"
import { ViewEditBox } from "../ViewEditBox"
import { ReactComponent as DroneSvg } from '../../../assets/drone.svg';
import './DroneView.css'

export const DroneView = (props) => {
    return (
        <div className="drone-item-margin">
            <ViewEditBox {...props} icon={<DroneSvg className="drone-icon" />} text={props.drone.make + ' ' + props.drone.model} />
        </div>
    )
}